import PostContainer from "src/container/post";
import { Helmet } from "react-helmet-async";

const Post = () => {
  return (
    <>
      <Helmet>
          <title>텔레모아::핵심 텔레그램 채널의 중요 정보를 모아!</title>
          <meta name="description" content="텔레그램에서 가장 핫한 투자정보는? 이 시각 인기 게시글을 텔레모아에서 가장 빠르게!" />
      </Helmet>
      <div className="container mt-4">
        <div className="row">
          <PostContainer rowPerPage={20} />
        </div>
      </div>
    </>
    
  );
}

export default Post;
